// extracted by mini-css-extract-plugin
export default {"fields":"src-feature-customer-list-__generate-opportunities_fields"};